import { logout } from '../auth.service';
import Login from '../../pages/Login';

const AlexandreRenault = () =>
{    
    localStorage.setItem("tenantId", "alexandrerenault");
    localStorage.setItem("logoVertical", "logoalexandrerenault");
    localStorage.setItem("logoHorizontal", "logoalexandrerenaultH");
    logout();
    
    return Login();
};

export default AlexandreRenault;